import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=4b2f5e16&scoped=true"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f5e16",
  null
  
)

export default component.exports